import clsx from 'clsx';
import { useInView } from 'react-intersection-observer';
import { useComposedRefs } from '../utils/use-composed-refs';
import { TabNav, TabNavProps } from './tab-nav';
import { stickyBar } from './tab-nav.css';

export const StickyTabNav = function StickyTabNav({
  ref: forwardedRef,
  className,
  ...props
}: TabNavProps & {
  ref?: React.Ref<HTMLDivElement>;
}) {
  const { ref, inView, entry } = useInView({
    // trick to trigger observer when sticky is active https://stackoverflow.com/a/61115077
    rootMargin: '-1px 0px 0px 0px',
    threshold: [1],
    initialInView: true,
  });

  const setRef = useComposedRefs(ref, forwardedRef);

  const stickyActive = !inView && entry?.intersectionRect.top === 1;

  return (
    <TabNav
      data-sticky={stickyActive ? '' : undefined}
      className={clsx(className, stickyBar)}
      {...props}
      ref={setRef}
    />
  );
};
